import columns from '../../../../react-table/helpers/columns';
import { sumTotal, totalRowRatio } from '../../../../react-table/helpers/rowTotals';

export const percentageConditionalProps = (state, rowInfo) => {
  let className = '';
  if (rowInfo) {
    const { row } = rowInfo;
    if (row) {
      className = 'text-grey';
      if (row.percentage < 50) {
        className = 'text-red';
      }
      if (row.percentage >= 50 && row.percentage < 80) {
        className = 'text-orange';
      }
    }
  }
  return {
    className,
  };
};

export default (data) => {
  const {
    TextColumn,
    DateTimeColumn,
    NonZeroNumberColumn,
    ExternalConsignmentLinkColumn,
    PercentageColumn,
  } = columns(data);

  return [
    {
      Header: 'Consignment',
      columns: [
        new ExternalConsignmentLinkColumn(new TextColumn('ID', 'consignment.id')),
        new TextColumn('Origin', 'consignment.origin').withGetProps(percentageConditionalProps),
        new TextColumn('Destination', 'consignment.destination').withGetProps(percentageConditionalProps),
        new TextColumn('Mail category', 'consignment.mailCategory').withGetProps(percentageConditionalProps),
        new TextColumn('Mail subclass', 'consignment.mailSubclass').withGetProps(percentageConditionalProps),
        new DateTimeColumn('Completion date', 'consignment.completionDateTime').withGetProps(percentageConditionalProps),
      ],
    },
    {
      Header: 'First Leg',
      columns: [
        new TextColumn('Conveyance reference', 'firstLeg.conveyanceReference').withGetProps(percentageConditionalProps),
        new DateTimeColumn('Planned departure', 'firstLeg.plannedDepartureTime').withGetProps(percentageConditionalProps),
      ],
    },
    {
      Header: 'Last Leg',
      columns: [
        new TextColumn('Conveyance reference', 'lastLeg.conveyanceReference').withGetProps(percentageConditionalProps),
        new DateTimeColumn('Planned arrival', 'lastLeg.plannedArrivalTime').withGetProps(percentageConditionalProps),
      ],
    },
    {
      Header: 'RESCON',
      columns: [
        new DateTimeColumn('First scan', 'rescon.firstScanTime').withGetProps(percentageConditionalProps),
        new DateTimeColumn('Last scan', 'rescon.lastScanTime').withGetProps(percentageConditionalProps),
        new TextColumn('First - last', 'rescon.scanDifference').withGetProps(percentageConditionalProps).withTotalHeader('Total'),
      ],
    },
    {
      Header: '',
      columns: [
        new NonZeroNumberColumn('PRECON', 'preconCount').withGetProps(percentageConditionalProps).withTotalHeader(sumTotal),
        new NonZeroNumberColumn('RESCON', 'resconCount').withGetProps(percentageConditionalProps).withTotalHeader(sumTotal),
        new PercentageColumn('%', 'percentage').withGetProps(percentageConditionalProps).withTotalHeader(totalRowRatio(['resconCount', 'preconCount'])),
      ],
    },
  ];
};
